const TarjetaMetrica = ({
    titulo,
    valor,
    secundario = null,
    loading = false,
    error = false,
    errorMensaje = 'No se pudo cargar este indicador',
    variante = 'default',
    className = '',
    children = null
}) => {
    const esOscura = variante === 'oscura';

    return (
        <div className={`card h-100 ${esOscura ? 'text-white' : ''} ${className}`} style={esOscura ? { backgroundColor: '#2f2c8a', borderColor: '#2f2c8a' } : undefined}>
            <div className="card-body d-flex flex-column">
                <h6 className={esOscura ? 'text-white-50 mb-2' : 'text-muted mb-2'} style={{ fontSize: 14, fontWeight: 600 }}>
                    {titulo}
                </h6>

                {loading ? (
                    <>
                        <div className="esqueleto" style={{ width: '55%' }} />
                        <div className="esqueleto" style={{ width: '80%', height: 26 }} />
                    </>
                ) : error ? (
                    <div className="text-danger" style={{ fontSize: 14 }}>
                        <i className="fas fa-triangle-exclamation me-1" />
                        {errorMensaje}
                    </div>
                ) : (
                    <>
                        <div className={esOscura ? 'fw-semibold' : 'fw-semibold text-dark'} style={{ fontSize: esOscura ? 40 : 30, lineHeight: 1.15 }}>
                            {valor}
                        </div>
                        {secundario}
                    </>
                )}

                {children}
            </div>
        </div>
    );
};

export default TarjetaMetrica;
